import { computePrefUnit } from 'utils/MeasurementsStoreFunctions';

import useAppSelector from './useAppSelector';

/**
 * Reactive hook version of getPrefUnitForMeasurementClass.
 * Re-renders the component when unit preferences or CITC config change.
 */
const usePrefUnitForMeasurementClass = (className: string): string => {
  const unitPreferences = useAppSelector((state) => state.settings.unitPreferences);
  const measurementClasses = useAppSelector(
    (state) => state.settings.citc?.measurementClasses || []
  );
  return computePrefUnit(className, unitPreferences, measurementClasses);
};

export default usePrefUnitForMeasurementClass;
